module.exports = __webpack_public_path__ + "static/playstore-8dd0c086ed60aa1e4fef9fb7f73c4f63.svg";